import Store from "@/store/index";

import OlapReportsList from "@/pages/olap-reports/list";
import OlapReport from "@/pages/olap-reports/report";

import { userPermissionsList } from "@/constants/userPermissions";

export default [
    {
        path: "/olap",
        name: "olap",
        component: OlapReportsList,
        meta: {
            title: "OLAP-отчёты",
        },
        beforeEnter: (to, from, next) => {
            if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                const { code } = to.query;
                const { olap } = userPermissionsList.reports;

                const permission = olap[code] || olap.calc;

                Store.dispatch("getUserPermissions").then(() => {
                    const userPermissions = Store.state.userPermissions;
                    const isAvailablePage = userPermissions.includes(permission);
                    if (isAvailablePage) {
                        next();
                    } else {
                        next({ name: "error-403" });
                    }
                });
            } else {
                window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
            }
        },
    },
    {
        path: "/olap-calculations",
        name: "olap-calculations",
        redirect: () => ({
            path: "/olap",
            query: {
                code: "calc",
            },
        }),
    },
    {
        path: "/olap-personal",
        name: "olap-personal",
        redirect: () => ({
            path: "/olap",
            query: {
                code: "personal",
            },
        }),
    },
    {
        path: "/olap-workers",
        name: "olap-workers",
        redirect: () => ({
            path: "/olap",
            query: {
                code: "worker",
            },
        }),
    },
    {
        path: "/olap/:id",
        name: "olap-report",
        component: OlapReport,
        meta: {
            ignore: true,
        },

        beforeEnter: (to, from, next) => {
            if (Store.state.authToken.length > 0 && Store.state.userId.length > 0) {
                const { code } = to.query;
                const { olap } = userPermissionsList.reports;

                const permission = olap[code] || olap.calc;

                Store.dispatch("getUserPermissions").then(() => {
                    const userPermissions = Store.state.userPermissions;
                    const isAvailablePage = userPermissions.includes(permission);
                    if (isAvailablePage) {
                        next();
                    } else {
                        next({ name: "error-403" });
                    }
                });
            } else {
                window.location.replace("/index.php?r=user-management%2Fauth%2Flogin");
            }
        },
    },
];
